<template>
  <SelectGroup :class="cn('p-1 w-full', props.class)" v-bind="delegatedProps">
    <slot />
  </SelectGroup>
</template>

<script setup>
import { computed } from 'vue';
import { SelectGroup } from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps({
  class: {
    type: String,
    required: false,
    default: '',
  },
  as: {
    type: String,
    required: false,
    default: 'div',
  },
  asChild: {
    type: String,
    required: false,
    default: 'div',
  },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>
